module.exports = __webpack_public_path__ + "nbell-exclamation.svg";